import angular from 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { MobileService } from './mobile.service';

angular.module('app-lite.mobile', [])
  .service('mobileApi', downgradeInjectable(MobileService));
